import { render, staticRenderFns } from "./DetailWithPipelines.vue?vue&type=template&id=365c4b20&"
import script from "./DetailWithPipelines.vue?vue&type=script&lang=ts&"
export * from "./DetailWithPipelines.vue?vue&type=script&lang=ts&"
import style0 from "./DetailWithPipelines.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports